import i18n from "@/i18n";

function _locale() {
  const lang = (i18n.language || "fr").split("-")[0];
  return lang === "en" ? "en-GB" : "fr-FR";
}

export const fr = {
  currency: (v) => new Intl.NumberFormat(_locale(), { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v ?? 0),
  number: (v, digits = 0) => new Intl.NumberFormat(_locale(), { maximumFractionDigits: digits }).format(v ?? 0),
  percent: (v, digits = 1) => {
    const n = new Intl.NumberFormat(_locale(), { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(v ?? 0);
    return _locale() === "en-GB" ? `${n}%` : `${n} %`;
  },
  months: (m) => {
    const lang = (i18n.language || "fr").split("-")[0];
    if (m == null) return lang === "en" ? "> horizon" : "> horizon";
    return lang === "en" ? `${m} months` : `${m} mois`;
  },
};
